import { NumberField } from 'Shared/forms/Inputs';
import { LabelOnRightWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export function LineHeight()
{
	return (
		<StyleFieldsRow>
			<LineHeightFields />
		</StyleFieldsRow>
	);
}


/* The line height on its own, for a caller that names the location itself - see ruleProperties(). A
   bare number is a multiple of the font size, exactly as the venue menu css used to write it. */
export function LineHeightFields()
{
	return (
		<LabelOnRightWrap label='×' narrow={true}>
			<NumberField field='lineHeight' step={0.1} />
		</LabelOnRightWrap>
	);
}
